module.exports = __webpack_public_path__ + "static/img/zhutuSTP070.9af5a48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/type3-5/zhutuSTP070.png
// module id = RwQU
// module chunks = 0